<template>
    <div class="zntmain">
        <div class="topbox">
            <div class="leftbox">
                <div class="back" v-if="smenu != 'info'" @click="backinfo"><i class="el-icon-arrow-left"></i></div>
                <!-- <div :class="menu == 'ai' ? 'btnitem btned' : 'btnitem'" @click="menuclick('ai')">AI智能监控</div> -->
                <div :class="menu == 'sd' ? 'btnitem btned' : 'btnitem'"  @click="menuclick('sd')">AI智能种莓</div>
            </div>
        </div>
        <div class="content">
            <Info  v-if="menu == 'ai' && smenu == 'info'" @gotalk="talkclick" @gopage="gopage" />
            <Talk v-if="menu == 'ai' && smenu == 'talk'" />
            <Upload v-if="menu == 'sd'" />
        </div>
    </div>

</template>

<script>
import Info from './coms/info.vue';
import Talk from './coms/talk.vue';
import Upload from './coms/upload.vue'
export default {
    name: 'index',
    components: { Info, Talk, Upload },
    data() {
        return {
            menu: 'sd',
            smenu: 'info'
            
        }
    },
    computed: {

    },
    mounted() {
    },
    methods: {
        gopage(e) {
            this.$emit('gopage', e)
        },
        backinfo() {
            switch (this.smenu) {
                case 'talk':
                    this.smenu = 'info'
                    break;
            
                default:
                    break;
            }
        },
        menuclick(e) {
            this.menu = e
        },
        talkclick() {
            this.smenu = 'talk'
        }
    }
}




</script>

<style scoped lang="less">
.zntmain {
    width: 100%;
    height: 100%;
    position: relative;
    background: linear-gradient( 129deg, #C8D598 0%, #DDE5C8 100%);
    padding: 12px;

    .topbox{
        width: 100%;
        display: flex;
        justify-content: space-between;
        .leftbox{
            display: flex;
            align-items: center;
            align-content: center;
            .back{
                padding: 6px 10px;
                background: rgba(255,255,255,0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 8px;
                font-size: 18px;
            }
            .btnitem{
                margin-left: 10px;
                font-size: 14px;
                padding: 8px 15px;
                background: rgba(255,255,255,0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 8px;
            }
            .btned{
                background: linear-gradient( 206deg, #FFAAC0 0%, #D94E6B 100%);
                color: #fff; 
                border: 0;
            }
        }
        .rightbox{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 12px;
            color: #00000080;
        }
    }

    .content{
        width: 100%;
        height: calc(100% - 25px);
    }

   
}
</style>
